<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';
import { isAuction } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}
const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt, tn } = useTypedI18n();

// DATA
const showBidsCount = computed(() => isAuction(sale) && sale.numberOfBids > 0);

const isVisible = computed((): boolean => showBidsCount.value || !!sale.visitorsCount);
</script>

<template>
    <div v-if="isVisible" class="bg-primary-50 space-y-1 rounded-xl px-6 py-2">
        <p v-if="showBidsCount && isAuction(sale)">
            {{ tt('sdp.numberOfBids', { count: sale.numberOfBids, formattedCount: tn(sale.numberOfBids, 'integer') }) }}
        </p>
        <p v-if="!!sale.visitorsCount">
            {{ tt('sdp.visitorsCount', { count: sale.visitorsCount, formattedCount: tn(sale.visitorsCount, 'integer') }) }}
        </p>
    </div>
</template>
